import Kyc from "../../components/UserDashboard/Kyc";
import Search from "../../components/UserDashboard/Search";
import SideBar from "../../components/UserDashboard/SideBar";
import "../../styles/UserDashboard/Verification.scss";
import Slider from "@mui/material/Slider";
import { userEmission as greenBasicUserEmission } from "../../instantiateTransaction/basicGreenProject";
import { userEmission as infrastructureBasicUserEmission } from "../../instantiateTransaction/basicInfrastructureChange";
import { userEmission as greenGovernanceUserEmission } from "../../instantiateTransaction/governanceGreenProject";
import { userEmission as infrastructureGovernanceUserEmission } from "../../instantiateTransaction/gorvernanceInfrastructureChange";
import { userEmission as monitoringGovernanceUserEmission } from "../../instantiateTransaction/governanceCarbonMonitoring";
import { getKyc, getUserInfo } from "../../apis/General/users";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Illustration from "../../images/9264828.jpg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Tabs, Tab } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyPDF from "../ThirdParty/MyPdf";
import EmissionReport from "../ThirdParty/EmissionReport";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Verification = () => {
  const [inProgress, setInProgress] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [companyName, setCompanyName] = useState("");

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const auth = useSelector((state) => state.auth);
  const getValidationData = async () => {
    setLoading(true);
    const response1 = await getKyc(auth?.userInfo?.id, auth?.token);
    console.log("same", response1);
    if (
      response1?.data?.message?.sustainabilitySolution ===
        "infrastructure-change" &&
      response1?.data?.message?.subscriptionPlan === "basic"
    ) {
      const response2 = await infrastructureBasicUserEmission(
        response1?.data?.message?.walletAddress
      );
      console.log('infrastructureBasicUserEmission', response2);
      setCompleted(response2.filter((item) => item?.isVerified === true));
      setInProgress(response2.filter((item) => item?.isVerified === false));
      // setRejected(response2.filter((item) => item?.isRejected === true));
    } else if (
      response1?.data?.message?.sustainabilitySolution ===
        "infrastructure-change" &&
      response1?.data?.message?.subscriptionPlan === "governance"
    ) {
      const response2 = await infrastructureGovernanceUserEmission(
        response1?.data?.message?.walletAddress
      );
      setCompleted(response2.filter((item) => item?.isVerified === true));
      setInProgress(response2.filter((item) => item?.isVerified === false));
      // setRejected(response2.filter((item) => item?.isRejected === true));
    } else if (
      response1?.data?.message?.facilityCategory === "green" &&
      response1?.data?.message?.subscriptionPlan === "basic"
    ) {
      const response29 = await greenBasicUserEmission(
        response1?.data?.message?.walletAddress
      );
      console.log("response29", response29);
      setCompleted(response29.filter((item) => item?.isVerified === true));
      setInProgress(response29.filter((item) => item?.isVerified === false));
      // setRejected(response2.filter((item) => item?.isRejected === true));
    } else if (
      response1?.data?.message?.facilityCategory === "green" &&
      response1?.data?.message?.subscriptionPlan === "governance"
    ) {
      const response29 = await greenGovernanceUserEmission(
        response1?.data?.message?.walletAddress
      );
      console.log("response29", response29);
      setCompleted(response29.filter((item) => item?.isVerified === true));
      setInProgress(response29.filter((item) => item?.isVerified === false));
      // setRejected(response2.filter((item) => item?.isRejected === true));
    } else if (
      response1?.data?.message?.sustainabilitySolution ===
        "carbon-monitoring" &&
      response1?.data?.message?.subscriptionPlan === "governance"
    ) {
      const response2 = await monitoringGovernanceUserEmission(
        response1?.data?.message?.walletAddress
      );
      // console.log("response2", response2);
      setCompleted(response2.filter((item) => item?.isVerified === true));
      setInProgress(response2.filter((item) => item?.isVerified === false));
      // setRejected(response2.filter((item) => item?.isRejected === true));
    }

    setLoading(false);
  };

  useEffect(() => {
    getValidationData();
  }, []);

  const fetchUserInfo = async () => {
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log("response fetchUserInfo", response);
    setCompanyName(response?.data?.message?.companyName);
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <div className="verification">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="main">
        <Search />

        {!inProgress?.length > 0 &&
        !loading &&
        !rejected?.length > 0 &&
        !loading &&
        !completed?.length > 0 &&
        !loading ? (
          <div className="main__no-data">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.1748 31.99L32.0028 29.163L44.0218 41.182L41.1938 44.009L29.1748 31.99Z"
                fill="#616161"
              />
              <path
                d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                fill="#616161"
              />
              <path
                d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                fill="#37474F"
              />
              <path
                d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                fill="#00AED9"
              />
              <path
                d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                fill="#BBDEFB"
              />
            </svg>
            <div className="main__no-data__title">
              Verification will begin once CO2 has been emitted, <br /> tracked,
              and calculated
            </div>
          </div>
        ) : (
          ""
        )}

        {inProgress?.length > 0 ||
        rejected?.length > 0 ||
        completed?.length > 0 ? (
          <Tabs
            value={value}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            className="tab_label_container"
          >
            <Tab
              className={value === 0 ? "tab_label tab_active" : "tab_label"}
              label="Verification in-progress"
              {...a11yProps(0)}
            />
            <Tab
              className={value === 1 ? "tab_label tab_active" : "tab_label"}
              label="Verification completed"
              {...a11yProps(1)}
            />
            {/* <Tab
              className={value === 2 ? "tab_label tab_active" : "tab_label"}
              label="Incomplete verification"
              {...a11yProps(2)}
            /> */}
          </Tabs>
        ) : (
          ""
        )}

        {loading && (
          <>
            <Skeleton
              width={200}
              height={20}
              borderRadius={8}
              style={{ marginBottom: "8px" }}
            />
            <Skeleton
              height={140}
              borderRadius={12}
              style={{ marginBottom: "36px" }}
            />
            <Skeleton
              width={200}
              height={20}
              borderRadius={8}
              style={{ marginBottom: "8px" }}
            />
            <Skeleton
              height={140}
              borderRadius={12}
              style={{ marginBottom: "36px" }}
            />
            <Skeleton
              width={200}
              height={20}
              borderRadius={8}
              style={{ marginBottom: "8px" }}
            />
            <Skeleton
              height={140}
              borderRadius={12}
              style={{ marginBottom: "36px" }}
            />
          </>
        )}
        {inProgress?.length > 0 && value === 0 ? (
          <>
            {/* <div className="verification_label progress">
              Verification in progress
            </div> */}
            <div className="verification_box_container">
              {inProgress?.map((data) => (
                <div className="verification_box">
                  <Slider
                    getAriaLabel={() => "Temperature range"}
                    value={1}
                    className="verification_bar"
                    // onChange={(e) => setPriceRange(e.target.value)}
                    valueLabelDisplay="auto"
                    // getAriaValueText={valuetext}
                    min={0}
                    max={2}
                    // marks={marks}
                  />
                  <div className="verification_box_flex">
                    <svg
                      className="verification_progress"
                      width="100"
                      height="101"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="50"
                        cy="50.5"
                        r="50"
                        fill="#00AED9"
                        fill-opacity="0.3"
                      />
                      <path
                        d="M96.3055 69.3626C93.1439 77.1241 88.0821 83.9663 81.5853 89.2604C75.0885 94.5546 67.3652 98.1307 59.1252 99.6603C50.8853 101.19 42.393 100.624 34.4291 98.0136C26.4651 95.4037 19.285 90.8339 13.5485 84.7241C7.81207 78.6143 3.70341 71.1606 1.60016 63.0481C-0.503081 54.9357 -0.533429 46.4246 1.51191 38.2973C3.55725 30.1701 7.61265 22.6873 13.3054 16.5367C18.9981 10.3862 26.1455 5.76524 34.0906 3.09861L38.8294 17.2175C33.2508 19.0899 28.2323 22.3345 24.2352 26.653C20.2381 30.9715 17.3906 36.2255 15.9545 41.932C14.5184 47.6385 14.5397 53.6145 16.0165 59.3106C17.4933 65.0067 20.3781 70.2402 24.4059 74.5301C28.4337 78.8201 33.4752 82.0288 39.067 83.8613C44.6588 85.6938 50.6216 86.0914 56.4072 85.0174C62.1928 83.9435 67.6156 81.4325 72.1773 77.7153C76.739 73.9981 80.2931 69.1938 82.513 63.7442L96.3055 69.3626Z"
                        fill="#00AED9"
                      />
                      <path
                        d="M25.8629 55.1989V53.0192L31.3281 44.4091H33.2074V47.4261H32.0952L28.6499 52.8786V52.9808H36.4162V55.1989H25.8629ZM32.1463 57.5V54.5341L32.1974 53.5689V44.4091H34.7926V57.5H32.1463ZM46.888 57.6918C45.8951 57.6918 45.0364 57.4808 44.312 57.0589C43.5918 56.6328 43.0357 56.0405 42.6436 55.282C42.2516 54.5192 42.0556 53.6349 42.0556 52.6293C42.0556 51.6151 42.2516 50.7287 42.6436 49.9702C43.0357 49.2074 43.5918 48.6151 44.312 48.1932C45.0364 47.767 45.8951 47.554 46.888 47.554C47.8809 47.554 48.7374 47.767 49.4576 48.1932C50.182 48.6151 50.7402 49.2074 51.1323 49.9702C51.5243 50.7287 51.7203 51.6151 51.7203 52.6293C51.7203 53.6349 51.5243 54.5192 51.1323 55.282C50.7402 56.0405 50.182 56.6328 49.4576 57.0589C48.7374 57.4808 47.8809 57.6918 46.888 57.6918ZM46.9007 55.5824C47.3525 55.5824 47.7296 55.4545 48.0321 55.1989C48.3347 54.9389 48.5627 54.5852 48.7161 54.1378C48.8738 53.6903 48.9526 53.1811 48.9526 52.6101C48.9526 52.0391 48.8738 51.5298 48.7161 51.0824C48.5627 50.6349 48.3347 50.2812 48.0321 50.0213C47.7296 49.7614 47.3525 49.6314 46.9007 49.6314C46.4448 49.6314 46.0613 49.7614 45.7502 50.0213C45.4434 50.2812 45.2111 50.6349 45.0534 51.0824C44.9 51.5298 44.8233 52.0391 44.8233 52.6101C44.8233 53.1811 44.9 53.6903 45.0534 54.1378C45.2111 54.5852 45.4434 54.9389 45.7502 55.1989C46.0613 55.4545 46.4448 55.5824 46.9007 55.5824ZM58.7708 47.6818V49.7273H52.7111V47.6818H58.7708ZM54.0982 57.5V46.9723C54.0982 46.2607 54.2367 45.6705 54.5137 45.2017C54.7949 44.733 55.1784 44.3814 55.6642 44.147C56.15 43.9126 56.7019 43.7955 57.3198 43.7955C57.7374 43.7955 58.1188 43.8274 58.464 43.8913C58.8134 43.9553 59.0733 44.0128 59.2438 44.0639L58.758 46.1094C58.6515 46.0753 58.5194 46.0433 58.3617 46.0135C58.2083 45.9837 58.0506 45.9688 57.8887 45.9688C57.4881 45.9688 57.209 46.0625 57.0513 46.25C56.8936 46.4332 56.8148 46.6911 56.8148 47.0234V57.5H54.0982ZM69.356 57.679C68.4526 57.679 67.6472 57.5128 66.9398 57.1804C66.2367 56.848 65.6784 56.3899 65.2651 55.8061C64.8517 55.2223 64.6365 54.5533 64.6195 53.799H67.3042C67.334 54.3061 67.5471 54.7173 67.9434 55.0327C68.3397 55.348 68.8105 55.5057 69.356 55.5057C69.7907 55.5057 70.1742 55.4098 70.5066 55.218C70.8432 55.022 71.1053 54.7514 71.2928 54.4062C71.4846 54.0568 71.5804 53.6562 71.5804 53.2045C71.5804 52.7443 71.4824 52.3395 71.2864 51.9901C71.0946 51.6406 70.8283 51.3679 70.4874 51.1719C70.1465 50.9759 69.7566 50.8757 69.3176 50.8714C68.9341 50.8714 68.5613 50.9503 68.199 51.108C67.8411 51.2656 67.562 51.4808 67.3617 51.7536L64.9007 51.3125L65.5208 44.4091H73.5236V46.6719H67.8027L67.464 49.951H67.5407C67.7708 49.6271 68.1181 49.3587 68.5826 49.1456C69.0471 48.9325 69.5669 48.826 70.1422 48.826C70.9306 48.826 71.6337 49.0114 72.2516 49.3821C72.8695 49.7528 73.3574 50.2621 73.7154 50.9098C74.0733 51.5533 74.2502 52.2947 74.2459 53.1342C74.2502 54.0163 74.0456 54.8004 73.6323 55.4865C73.2232 56.1683 72.65 56.7053 71.9128 57.0973C71.1799 57.4851 70.3276 57.679 69.356 57.679Z"
                        fill="#1A1A1A"
                      />
                    </svg>

                    {/* <div className="verification_progress">2 of 2</div> */}
                    <div className="verification_tick_group">
                      <div className="verification_tick">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Tracked
                        </div>
                      </div>
                      <div className="verification_tick">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Calculated
                        </div>
                      </div>
                      <div className="verification_tick">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Emission <br /> reduction
                        </div>
                      </div>
                      {/* <div className="verification_tick">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> monitored
                        </div>
                      </div> */}

                      <div className="verification_tick progress_tick">
                        <div>
                          <svg
                            width="32"
                            height="33"
                            viewBox="0 0 32 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="16"
                              cy="16.5"
                              r="16"
                              fill="#00AED9"
                              fill-opacity="0.3"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> verified
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          ""
        )}

        {/* {!inProgress?.length > 0 && value === 0 ? (
          <div className="main__no-data">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.1748 31.99L32.0028 29.163L44.0218 41.182L41.1938 44.009L29.1748 31.99Z"
                fill="#616161"
              />
              <path
                d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                fill="#616161"
              />
              <path
                d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                fill="#37474F"
              />
              <path
                d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                fill="#00AED9"
              />
              <path
                d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                fill="#BBDEFB"
              />
            </svg>
            <div className="main__no-data__title">
              Your facility does not have any verification in progress
            </div>
          </div>
        ) : (
          ""
        )} */}
        {completed?.length > 0 && value === 1 ? (
          <>
            {/* <div className="verification_label completed">
              Verification completed
            </div> */}
            <div className="verification_box_container">
              {completed?.map((data) => (
                <div className="verification_box">
                  <Slider
                    getAriaLabel={() => "Temperature range"}
                    value={2}
                    className="verification_bar_completed"
                    // onChange={(e) => setPriceRange(e.target.value)}
                    valueLabelDisplay="auto"
                    // getAriaValueText={valuetext}
                    min={0}
                    max={2}
                    // marks={marks}
                  />
                  <div className="verification_box_flex">
                    <svg
                      className="verification_progress"
                      width="100"
                      height="101"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="50" cy="50.5" r="50" fill="white" />
                      <path
                        d="M100 50.5C100 78.1142 77.6142 100.5 50 100.5C22.3858 100.5 0 78.1142 0 50.5C0 22.8858 22.3858 0.5 50 0.5C77.6142 0.5 100 22.8858 100 50.5ZM14.893 50.5C14.893 69.8891 30.6109 85.607 50 85.607C69.3891 85.607 85.107 69.8891 85.107 50.5C85.107 31.1109 69.3891 15.393 50 15.393C30.6109 15.393 14.893 31.1109 14.893 50.5Z"
                        fill="#0F973D"
                      />
                      <path
                        d="M30.8423 57.679C29.9389 57.679 29.1335 57.5128 28.4261 57.1804C27.723 56.848 27.1648 56.3899 26.7514 55.8061C26.3381 55.2223 26.1229 54.5533 26.1058 53.799H28.7905C28.8203 54.3061 29.0334 54.7173 29.4297 55.0327C29.826 55.348 30.2969 55.5057 30.8423 55.5057C31.277 55.5057 31.6605 55.4098 31.9929 55.218C32.3295 55.022 32.5916 54.7514 32.7791 54.4062C32.9709 54.0568 33.0668 53.6562 33.0668 53.2045C33.0668 52.7443 32.9688 52.3395 32.7727 51.9901C32.581 51.6406 32.3146 51.3679 31.9737 51.1719C31.6328 50.9759 31.2429 50.8757 30.804 50.8714C30.4205 50.8714 30.0476 50.9503 29.6854 51.108C29.3274 51.2656 29.0483 51.4808 28.848 51.7536L26.3871 51.3125L27.0071 44.4091H35.0099V46.6719H29.2891L28.9503 49.951H29.027C29.2571 49.6271 29.6044 49.3587 30.0689 49.1456C30.5334 48.9325 31.0533 48.826 31.6286 48.826C32.4169 48.826 33.12 49.0114 33.7379 49.3821C34.3558 49.7528 34.8438 50.2621 35.2017 50.9098C35.5597 51.5533 35.7365 52.2947 35.7322 53.1342C35.7365 54.0163 35.532 54.8004 35.1186 55.4865C34.7095 56.1683 34.1364 56.7053 33.3991 57.0973C32.6662 57.4851 31.8139 57.679 30.8423 57.679ZM46.2903 57.6918C45.2974 57.6918 44.4387 57.4808 43.7143 57.0589C42.9941 56.6328 42.438 56.0405 42.046 55.282C41.6539 54.5192 41.4579 53.6349 41.4579 52.6293C41.4579 51.6151 41.6539 50.7287 42.046 49.9702C42.438 49.2074 42.9941 48.6151 43.7143 48.1932C44.4387 47.767 45.2974 47.554 46.2903 47.554C47.2832 47.554 48.1397 47.767 48.8599 48.1932C49.5843 48.6151 50.1426 49.2074 50.5346 49.9702C50.9267 50.7287 51.1227 51.6151 51.1227 52.6293C51.1227 53.6349 50.9267 54.5192 50.5346 55.282C50.1426 56.0405 49.5843 56.6328 48.8599 57.0589C48.1397 57.4808 47.2832 57.6918 46.2903 57.6918ZM46.3031 55.5824C46.7548 55.5824 47.1319 55.4545 47.4345 55.1989C47.737 54.9389 47.965 54.5852 48.1184 54.1378C48.2761 53.6903 48.3549 53.1811 48.3549 52.6101C48.3549 52.0391 48.2761 51.5298 48.1184 51.0824C47.965 50.6349 47.737 50.2812 47.4345 50.0213C47.1319 49.7614 46.7548 49.6314 46.3031 49.6314C45.8471 49.6314 45.4636 49.7614 45.1525 50.0213C44.8457 50.2812 44.6135 50.6349 44.4558 51.0824C44.3024 51.5298 44.2257 52.0391 44.2257 52.6101C44.2257 53.1811 44.3024 53.6903 44.4558 54.1378C44.6135 54.5852 44.8457 54.9389 45.1525 55.1989C45.4636 55.4545 45.8471 55.5824 46.3031 55.5824ZM58.1731 47.6818V49.7273H52.1135V47.6818H58.1731ZM53.5005 57.5V46.9723C53.5005 46.2607 53.639 45.6705 53.916 45.2017C54.1973 44.733 54.5808 44.3814 55.0666 44.147C55.5524 43.9126 56.1042 43.7955 56.7221 43.7955C57.1397 43.7955 57.5211 43.8274 57.8663 43.8913C58.2157 43.9553 58.4757 44.0128 58.6461 44.0639L58.1603 46.1094C58.0538 46.0753 57.9217 46.0433 57.764 46.0135C57.6106 45.9837 57.4529 45.9688 57.291 45.9688C56.8904 45.9688 56.6113 46.0625 56.4537 46.25C56.296 46.4332 56.2172 46.6911 56.2172 47.0234V57.5H53.5005ZM68.7583 57.679C67.8549 57.679 67.0495 57.5128 66.3422 57.1804C65.639 56.848 65.0808 56.3899 64.6674 55.8061C64.2541 55.2223 64.0389 54.5533 64.0218 53.799H66.7065C66.7363 54.3061 66.9494 54.7173 67.3457 55.0327C67.742 55.348 68.2129 55.5057 68.7583 55.5057C69.193 55.5057 69.5765 55.4098 69.9089 55.218C70.2456 55.022 70.5076 54.7514 70.6951 54.4062C70.8869 54.0568 70.9828 53.6562 70.9828 53.2045C70.9828 52.7443 70.8848 52.3395 70.6887 51.9901C70.497 51.6406 70.2306 51.3679 69.8897 51.1719C69.5488 50.9759 69.1589 50.8757 68.72 50.8714C68.3365 50.8714 67.9636 50.9503 67.6014 51.108C67.2434 51.2656 66.9643 51.4808 66.764 51.7536L64.3031 51.3125L64.9231 44.4091H72.926V46.6719H67.2051L66.8663 49.951H66.943C67.1731 49.6271 67.5204 49.3587 67.9849 49.1456C68.4494 48.9325 68.9693 48.826 69.5446 48.826C70.3329 48.826 71.036 49.0114 71.6539 49.3821C72.2718 49.7528 72.7598 50.2621 73.1177 50.9098C73.4757 51.5533 73.6525 52.2947 73.6483 53.1342C73.6525 54.0163 73.448 54.8004 73.0346 55.4865C72.6255 56.1683 72.0524 56.7053 71.3152 57.0973C70.5822 57.4851 69.7299 57.679 68.7583 57.679Z"
                        fill="#1A1A1A"
                      />
                    </svg>

                    {/* <div className="verification_progress">2 of 2</div> */}

                    <div className="verification_tick_group">
                      <div className="verification_tick verification_tick_completed">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Tracked
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_completed">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Calculated
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_completed">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Emission <br /> reduction
                        </div>
                      </div>
                      {/* <div className="verification_tick verification_tick_completed">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> monitored
                        </div>
                      </div> */}

                      <div className="verification_tick verification_tick_completed">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> verified
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="verification-box__divider"></div>
                  <PDFDownloadLink
                    document={
                      <EmissionReport
                        companyName={companyName}
                        reduction={
                          data?.quantifiedGHGEmissionsInBaselineScenario -
                          data?.totalGHGEmission
                        }
                      />
                    }
                    fileName={`${companyName}-Netzence certificate.pdf`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="verification-box__link pointer">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.99902 14.4999C1.99902 15.0909 2.11542 15.6761 2.34157 16.222C2.56771 16.768 2.89918 17.2641 3.31704 17.6819C4.16096 18.5258 5.30555 18.9999 6.49902 18.9999H18.499C19.385 19.0015 20.2386 18.6671 20.8876 18.064C21.5367 17.461 21.9329 16.6343 21.9963 15.7506C22.0598 14.8669 21.7857 13.992 21.2295 13.3024C20.6732 12.6129 19.8761 12.1599 18.999 12.0349C19.0088 10.3337 18.3987 8.68714 17.2827 7.40304C16.1667 6.11894 14.6213 5.28519 12.9353 5.05766C11.2494 4.83012 9.53823 5.22438 8.12179 6.16672C6.70536 7.10906 5.68058 8.53498 5.23902 10.1779C4.30414 10.451 3.48301 11.0198 2.89882 11.799C2.31464 12.5783 1.99892 13.526 1.99902 14.4999Z"
                          stroke="#0D924F"
                          stroke-width="1.5"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.99902 12.9999L11.999 14.9999M11.999 14.9999L13.999 12.9999M11.999 14.9999V8.99988"
                          stroke="#0D924F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Download verification certification for this emission
                    </div>
                  </PDFDownloadLink>
                </div>
              ))}
            </div>
          </>
        ) : (
          ""
        )}

        {/* {!completed?.length > 0 && value === 1 ? (
          <div className="main__no-data">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.1748 31.99L32.0028 29.163L44.0218 41.182L41.1938 44.009L29.1748 31.99Z"
                fill="#616161"
              />
              <path
                d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                fill="#616161"
              />
              <path
                d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                fill="#37474F"
              />
              <path
                d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                fill="#00AED9"
              />
              <path
                d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                fill="#BBDEFB"
              />
            </svg>
            <div className="main__no-data__title">
              Your facility does not have any verification in progress
            </div>
          </div>
        ) : (
          ""
        )} */}
        {rejected?.length > 0 && value === 2 ? (
          <>
            {/* <div className="verification_label failed">
              Incomplete verification
            </div> */}
            {rejected?.map((data) => (
              <div className="verification_box_container">
                <div className="verification_box">
                  <Slider
                    getAriaLabel={() => "Temperature range"}
                    value={2}
                    className="verification_bar_failed"
                    // onChange={(e) => setPriceRange(e.target.value)}
                    valueLabelDisplay="auto"
                    // getAriaValueText={valuetext}
                    min={0}
                    max={2}
                    // marks={marks}
                  />
                  <div className="verification_box_flex">
                    {/* <div className="verification_progress verification_error">
                <svg
                  width="54"
                  height="55"
                  viewBox="0 0 54 55"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M4 1L49.5 54.5" stroke="#D42620" />
                  <path d="M0.5 50.5L53.5 4.5" stroke="#D42620" />
                </svg>
              </div> */}
                    <svg
                      className="verification_progress"
                      width="100"
                      height="101"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="50" cy="50.5" r="50" fill="white" />
                      <path
                        d="M100 50.5C100 78.1142 77.6142 100.5 50 100.5C22.3858 100.5 0 78.1142 0 50.5C0 22.8858 22.3858 0.5 50 0.5C77.6142 0.5 100 22.8858 100 50.5ZM14.893 50.5C14.893 69.8891 30.6109 85.607 50 85.607C69.3891 85.607 85.107 69.8891 85.107 50.5C85.107 31.1109 69.3891 15.393 50 15.393C30.6109 15.393 14.893 31.1109 14.893 50.5Z"
                        fill="#D42620"
                      />
                      <path d="M27 24L72.5 77.5" stroke="#D42620" />
                      <path d="M23.5 73.5L76.5 27.5" stroke="#D42620" />
                    </svg>

                    <div className="verification_tick_group">
                      <div className="verification_tick verification_tick_error">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Tracked
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_error">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Calculated
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_error">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Emission <br /> reduced
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_error">
                        <div>
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.25 9.25L6.75 12.75L13.75 5.25"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Monitored
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_error">
                        <div>
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="16"
                              cy="16"
                              r="15.5"
                              fill="white"
                              stroke="#D42620"
                            />
                            <path
                              d="M12.5053 19.4953L16.0006 16L19.496 19.4953M19.496 12.5046L16 16L12.5053 12.5046"
                              stroke="#D42620"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Validated
                        </div>
                      </div>
                      <div className="verification_tick verification_tick_error">
                        <div>
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="16"
                              cy="16"
                              r="15.5"
                              fill="white"
                              stroke="#D42620"
                            />
                            <path
                              d="M12.5053 19.4953L16.0006 16L19.496 19.4953M19.496 12.5046L16 16L12.5053 12.5046"
                              stroke="#D42620"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div>
                          Carbon <br /> Verified
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          ""
        )}
      </div>

    </div>
  );
};

export default Verification;
